<template>
  <div class="framer-73frtw" data-framer-name="Section Hero" name="Section Hero">
    <div style="position:absolute;border-radius:inherit;top:0;right:0;bottom:0;left:0"
      data-framer-background-image-wrapper="true"><img decoding="async" sizes="100vw"
        :src="heroBanner" alt=""
        style="display:block;width:100%;height:100%;border-radius:inherit;object-position:center;object-fit:cover">
        <!-- ./Smart Factory Recognition Program - Transform Your Business_files/W7cYzJZrgTJgh5nNw9RwEudBVes.png -->
    </div>
    <div class="framer-1mmyhhe">
      <div class="framer-1h74zpr"></div>
    </div>
    <div class="framer-1o9aqba">
      <div class="framer-1w7uzkp"></div>
      <div class="framer-1mcsz2f">
        <div class="framer-3yblv3">
          <div class="framer-e4h6im">
            <div class="framer-1pdyvrh">
              <div data-framer-component-type="SVG" style="image-rendering:pixelated;flex-shrink:0"
                class="framer-16h9lap" aria-hidden="true">
                <div class="svgContainer" style="width:100%;height:100%;aspect-ratio:inherit"><svg
                    style="width:100%;height:100%">
                    <!-- <use href="#svg12681770904"></use> -->
                    <svg viewBox="0 0 151 143">
                      <path d="M 131.348 19.416 L 9.166 67.869 L 9.166 131.758" fill="transparent" stroke-width="0.86"
                        stroke="rgb(255, 255, 255)"></path>
                      <path
                        d="M 131.348 9.983 C 136.539 9.983 140.747 14.207 140.747 19.416 C 140.747 24.626 136.539 28.85 131.348 28.85 C 126.158 28.85 121.95 24.626 121.95 19.416 C 121.95 14.207 126.158 9.983 131.348 9.983 Z"
                        fill="var(--token-a0c2593c-6916-4188-ac50-f5131b23cc3f, rgb(255, 255, 255)) /* {&quot;name&quot;:&quot;White&quot;} */">
                      </path>
                      <path
                        d="M 131.348 0.55 C 141.73 0.55 150.146 8.997 150.146 19.416 C 150.146 29.836 141.73 38.283 131.348 38.283 C 120.967 38.283 112.551 29.836 112.551 19.416 C 112.551 8.997 120.967 0.55 131.348 0.55 Z"
                        fill="transparent" stroke-width="0.86" stroke="rgb(255, 255, 255)"></path>
                      <path
                        d="M 9.44 123.522 C 14.631 123.522 18.839 127.745 18.839 132.955 C 18.839 138.165 14.631 142.388 9.44 142.388 C 4.249 142.388 0.041 138.165 0.041 132.955 C 0.041 127.745 4.249 123.522 9.44 123.522 Z"
                        fill="var(--token-a8d4d279-80d0-45a4-9f3d-79620f9c0f86, rgb(253, 184, 18)) /* {&quot;name&quot;:&quot;Secondary&quot;} */">
                      </path>
                    </svg>
                  </svg></div>
              </div>
            </div>
            <div class="framer-n7g3gx">
              <div class="framer-1og6nob"
                style="outline:none;display:flex;flex-direction:column;justify-content:flex-start;flex-shrink:0;transform:none"
                data-framer-component-type="RichTextContainer">
                <h1 class="framer-text framer-styles-preset-1jl24al" data-styles-preset="qUAP_U6x_">Smart Factory
                  <br class="framer-text">Excellence and Recognition Assessment
                </h1>
              </div>
            </div>
          </div>
          <div class="framer-gdm2ke"
            style="outline:none;display:flex;flex-direction:column;justify-content:flex-start;flex-shrink:0;transform:none"
            data-framer-component-type="RichTextContainer">
            <p class="framer-text framer-styles-preset-1lmyodd" data-styles-preset="c2hROzLaY"
              style="--framer-text-color:var(--token-a0c2593c-6916-4188-ac50-f5131b23cc3f, rgb(255, 255, 255))">
              Under Mission 2 of the New Industrial Master Plan (NIMP) 2030 under the Ministry of Investment, Trade
              and industry (MITI) with SIRIM and Strategic Partners, is designed to accelerate the conversion of
              3000 companies into Smart Factories by 2030</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import factorylane from '@/assets/factorylane.png'
import heroBanner from '@/assets/hero-banner-replacement-ver5.png'

export default {
  name: 'part-1-landing-page',
  inheritAttrs: false,
  data() {
    return {
      heroBanner
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/sfera/components/Part1LandingPage/index.vue